import React, { useEffect, useState } from 'react'
import { Collapse, Icon } from 'antd';
import { Button, FormDatePicker, FormSelect, FormSubmitButton, MasterDetailForm, Row, Table, Widget } from '@digital/ui'
import { dadosGeraisState, ordemCompraIdState, reloadState } from '../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { GetSasConsicaoPagamentoOptions } from '@app/api/sas/sasProposta';
import CurrencyInput from '@app/components/CurrencyInput';
import { Visibility } from '@app/components';
import { updateAbaAditivoCommand } from '@app/api/sas/ordemCompra';
import * as Yup from 'yup';
import { ETipoContrato } from '@app/enums/ETipoContrato';



interface Props {
    parteDoFluxo?: boolean
    ehComprador?: boolean
    valorTotal: number | undefined;
    data: any;
}

const WidgetAditivo = ({
    parteDoFluxo = false,
    ehComprador = false,
    valorTotal,
    data
}: Props) => {
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [selectAditivos, setSelectAditivos] = useState<string[]>([]);
    const [valorAditivo, setValorAditivo] = useState<number | undefined>();
    const [reload, setReload] = useRecoilState(reloadState);
    const dadosGerais = useRecoilValue(dadosGeraisState);

    const ehPCS = (dadosGerais.modalidadeContratoTotvs || '').toLocaleLowerCase() === ETipoContrato.PCS;

    const handleSubmitWidgetAditivo = async (values: any) => {
        if (selectAditivos.length == 0) return
        let valuesToSend = {
            OrdemCompraId: ordemCompraId,
            IsPrazo: selectAditivos.indexOf('1') !== -1,
            IsClausula: selectAditivos.indexOf('2') !== -1,
            IsValorSemAcrescimoEscopo: selectAditivos.indexOf('3') !== -1,
            IsRemanejamentoVerbasEntreLinhas: selectAditivos.indexOf('4') !== -1,
            IsValorComAcrescimoEscopo: selectAditivos.indexOf('5') !== -1,
            IsAcrescimoEscopoRemanejamentoVerba: selectAditivos.indexOf('6') !== -1,
        };

        if (selectAditivos.indexOf('1') !== -1) {
            valuesToSend = { ...valuesToSend, dataFinalAditivo: values.dataFinalAditivo }
        }

        if (selectAditivos.indexOf('3') !== -1) {
            valuesToSend = { ...valuesToSend, sasCondicaoPagamentoId: values.sasCondicaoPagamentoId, valorAditivo }
        }
        await updateAbaAditivoCommand(valuesToSend).finally(() => setReload(!reload));
    };

    useEffect(() => {
        if (data) {
            var valuesSelect: string[] = [];
            if (data.isPrazo) valuesSelect = [...valuesSelect, '1'];
            if (data.isClausula) valuesSelect = [...valuesSelect, '2'];
            if (data.isValorSemAcrescimoEscopo) valuesSelect = [...valuesSelect, '3'];
            if (data.isRemanejamentoVerbasEntreLinhas) valuesSelect = [...valuesSelect, '4'];
            setSelectAditivos(valuesSelect);
            setValorAditivo(data.valorAditivo);
        }
    }, [data])

    return (
        <>
            <Collapse
                bordered={false}
                defaultActiveKey="aditivo"
                expandIcon={() => <Icon type="arrows-right_4" />}>
                <Collapse.Panel header={ehPCS ? 'Aditivo PCS' : 'Aditivo'} key="aditivo">
                    <MasterDetailForm
                        onSubmit={handleSubmitWidgetAditivo}
                        initialValues={data}
                        validationSchema={Yup.object().shape({
                            caracteristicasAditivo: Yup.array().test('is_min', 'Campo obrigatório', (value) => {
                                return selectAditivos.length > 0
                            }),
                        })}
                        actions={[
                            <>
                               <Visibility
                                visible={ehComprador}
                                >
                                <FormSubmitButton
                                    
                                    style={{ margin: 10 }}
                                    type="primary"
                                    title="Salvar"
                                    noIcon
                                />
                                </Visibility>
                            </>
                        ]}
                    >
                        <Row>
                            <FormSelect
                                span={12}
                                showSearch
                                mode="multiple"
                                label={ehPCS ? 'Característica do Aditivo PCS' : 'Característica do Aditivo'}
                                name="caracteristicasAditivo"
                                value={selectAditivos}
                                onChange={e => setSelectAditivos(e)}
                                options={[
                                    {
                                        text: 'Prazo',
                                        value: '1'
                                    },
                                    {
                                        text: 'Cláusula',
                                        value: '2'
                                    },
                                    {
                                        text: 'Valor',
                                        value: '3'
                                    },
                                    {
                                        text: 'Remanejamento de Verbas Entre Linhas',
                                        value: '4'
                                    }
                                ]}
                            />
                        </Row>
                        <Row>
                            
                            <Visibility
                                visible={selectAditivos.indexOf('1') !== -1}
                            >
                                <FormDatePicker
                                    label={ehPCS ? 'Data Final do Aditivo PCS' : 'Data Final do Aditivo'}
                                    name="dataFinalAditivo"
                                    format="DD/MM/YYYY"
                                    span={3}
                                    required
                                />
                            </Visibility>
                            <Visibility
                                visible={
                                    selectAditivos.indexOf('3') !== -1
                                }
                            >
                                <FormSelect
                                    label='Condição de Pagamento'
                                    name="sasCondicaoPagamentoId"
                                    getOptions={GetSasConsicaoPagamentoOptions}
                                    span={3}
                                    required
                                />
                                <CurrencyInput
                                    label={ehPCS ? 'Valor do Aditivo PCS' : 'Valor do Aditivo'}
                                    name='valorAditivo'
                                    value={valorAditivo}
                                    onChange={e => setValorAditivo(e)}
                                    span={3}
                                    required={valorAditivo == undefined}
                                />
                                <CurrencyInput
                                    label={ehPCS ? 'Valor Total PCS Acumulado' : 'Valor Total Contrato Acumulado'}
                                    name=''
                                    value={valorTotal && valorAditivo ? (valorTotal + valorAditivo) : (valorTotal)}
                                    span={3}
                                    disabled
                                />
                            </Visibility>
                        </Row>
                    </MasterDetailForm>
                </Collapse.Panel>
            </Collapse>
        </>
    )
}

export default WidgetAditivo